/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(document).ready(function () {
  // # Custom media splash slideshow.
  ////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////
  var $splash = $(".splash");
  var $loader = $(".splash__loader");
  var $media = $(".splash__media-slider");
  var $nav = $(".splash__nav-slider");

  var maxCount, initialIndex, mediaSlider, navSlider;

  if ($splash) {
    if ($media && $nav) {
      // Remove loader after slider initialises and update component state.
      $media.on("ready.flickity", function () {
        if ($loader) {
          $loader.fadeOut(1500, function () {
            $splash.addClass("splash--ready");
          });
        }
      });

      // Randomise starting slide index.
      maxCount = $media.find(".splash__media-slide").length;
      initialIndex = Math.floor(Math.random() * maxCount);

      // Initialise media slider.
      mediaSlider = $media.flickity({
        cellAlign: "left",
        wrapAround: true,
        autoPlay: 4000,
        pauseAutoPlayOnHover: false,
        prevNextButtons: false,
        pageDots: false,
        initialIndex: initialIndex,
      });

      // Initialise navigation slider.
      navSlider = $nav.flickity({
        cellAlign: "center",
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        initialIndex: initialIndex,
      });

      // Automatically resume media slider autoplay after a set timeout,
      // when user stops interacting with it.
      mediaSlider.on("pointerUp.flickity", function () {
        resumeMediaSliderAfterTimeout();
      });

      // Bind both media and navigation sliders so
      // when one changes, update the other.
      mediaSlider.on("change.flickity", function (event, index) {
        navSlider.flickity("select", index);
      });

      navSlider.on("click", ".splash__btn", function () {
        // Stop media slider autoplay to mirror media slider's own change handlers.
        // Transit to corresponding slide and start resume timer.
        mediaSlider.flickity("stopPlayer");
        resumeMediaSliderAfterTimeout();

        var index = $(this).data("index");
        mediaSlider.flickity("select", index);
      });

      // Method for resuming media slider after set timer.
      function resumeMediaSliderAfterTimeout() {
        setTimeout(function () {
          mediaSlider.flickity("playPlayer");
        }, 6000);
      }
    }
  }
});
